import React from 'react';

// reactstrap components
import {
    Button
} from "reactstrap";

// Fontawesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

export default function LSRS() {
  
    return (
        <div className="GraphContent">
            <div style={{justifyContent: 'flex-start', alignItems: 'center', gap: '5px', display: 'inline-flex', flexDirection: 'column'}}>
                <div className="searchExampleText">하단 버튼 클릭 시에 <span style={{color: '#0B1659'}}>별도 화면</span>으로 제공됩니다</div>
                <div>
                    <Button
                    className="selectBtn" style={{width:'200px'}}
                    onClick={() => {
                        window.open("http://lonesmartlsrs.duckdns.org", "_blank"); // Replace this with your URL
                    }}>
                    LSRS Monitoring 이동 <FontAwesomeIcon icon={faArrowRight} />
                    </Button>
                </div>
            </div>
        </div>
    );
  }